import React, { ChangeEventHandler, useState } from 'react';
import { getSelectStyles } from './styleUtils';
import { Select as SelectHeadless } from '@headlessui/react';
import { ChevronDown, Loader } from 'react-feather';
interface Option {
	value: string;
	label: string;
}

interface SelectProps {
	value: any;
	options: Option[] | [];
	onChange: ChangeEventHandler<HTMLSelectElement>;
	label?: string | React.ReactNode;
	disabled?: boolean;
	name: string;
	loading?: boolean;
	shape?: 'pill' | 'default';
	dataTestId?: string;
}

const Select: React.FC<SelectProps> = ({
	value,
	options,
	onChange,
	label,
	disabled,
	name,
	loading,
	shape = 'default',
	dataTestId
}) => {
	const styles = getSelectStyles();
	const [isFocused, setIsFocused] = useState(false);

	const componentStyles = () => {
		const baseStyles = styles.selectContainerCss;
		const pillShapeStyles = shape === 'pill' ? styles.selectContainerPillCss : {};
		const focusedStyles = isFocused ? styles.focusedSelectContainerCss : {};
		const disabledStyles = disabled || loading ? styles.disabledSelectContainerCss : {};

		return {
			...baseStyles,
			...pillShapeStyles,
			...focusedStyles,
			...disabledStyles
		};
	};
	return (
		<div style={styles.containerCss as React.CSSProperties}>
			<label htmlFor={name} style={styles.inputLabel}>
				{label}
			</label>
			<div style={componentStyles()}>
				<SelectHeadless
					data-testid={dataTestId}
					style={styles.selectCss}
					value={value}
					onChange={onChange}
					disabled={disabled || loading}
					name={name}
					onFocus={() => setIsFocused(true)}
					onBlur={() => setIsFocused(false)}
					aria-label={name}
				>
					{options.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</SelectHeadless>
				{loading ? (
					<Loader
						size={18}
						style={styles.loadingIconCss}
						className="spin-animation"
						data-testid="loading-icon"
					/>
				) : (
					<ChevronDown size={18} />
				)}
			</div>
		</div>
	);
};

export default Select;
